export default "__VITE_ASSET__DgM_1Efl__"